import _ from 'underscore';
import PropTypes from 'prop-types';
import React from 'react';
import { memoize } from '@bingads-webui-universal/primitive-utilities';
import { CampaignOData } from '@bingads-webui-react/campaign-odata';
import { withScope, QueryParam } from '@bingads-webui-react/scope-service';
import { withGlobalFilter } from '@bingads-webui-react/global-filter-context';
import { CampaignType, siteMapPropType, getCurrentScope } from '@bingads-webui-react/with-site-map';
import { filterMapItem } from './processor-helpers';

const defaultCampaign = { CampaignType: CampaignType.All };

function smartShoppingCampaignFilter(
  campaign,
  currentScope,
  { smartShoppingCampaignScope }
) {
  const isScopedSmartShoppingCampaign = campaign && campaign.Id ?
    campaign.CampaignSubType === 'ShoppingSmartAds' :
    false;

  if (isScopedSmartShoppingCampaign && smartShoppingCampaignScope &&
    !_.contains(smartShoppingCampaignScope, currentScope)) {
    // Hide page not support in current scope.
    return false;
  }

  return true;
}

const filterMapItemByCampaign = (siteMap, currentScope, currentCampaign) => {
  const campaignFilter = (campaign, item) =>
    smartShoppingCampaignFilter(campaign, currentScope, item);

  return filterMapItem(siteMap, _.partial(campaignFilter, currentCampaign));
};

const filterMapItemByCampaignCached = memoize(filterMapItemByCampaign);

/**
 * Only for testing
 */
export const testRef = { current: undefined };

export function processSmartShoppingCampaign(Component) {
  const Wrapper = ({ siteMap, ...props }) => {
    const {
      scope: { values: { aid, campaignId, adGroupId } },
    } = props;
    const currentScope = getCurrentScope(campaignId, adGroupId, aid);

    const processor = campaign => (<Component
      {...props}
      siteMap={filterMapItemByCampaignCached(siteMap, currentScope, campaign)}
    />);

    return (
      <CampaignOData
        call={({ currentCampaign }) => currentCampaign.get()}
        escapeHatch={({ currentCampaign }) => (currentCampaign ? undefined : {})}
        fallback={processor(defaultCampaign)}
        onError={() => processor(defaultCampaign)}
        testRef={testRef}
      >
        {campaign => processor(campaign)}
      </CampaignOData>
    );
  };

  Wrapper.propTypes = {
    siteMap: siteMapPropType.isRequired,
    scope: PropTypes.instanceOf(QueryParam).isRequired,
  };

  return withGlobalFilter(withScope(Wrapper));
}
